import Type from "@/model/types/Type";


const type = {
    LOCADOR: 1,
    LOCATARIO: 2,
    FIADOR: 3,
    TESTEMUNHA: 4

}

const list = [
    {
        value: type.LOCATARIO,
        text: "Locatário",
    },
    {
        value: type.FIADOR,
        text: "Fiador",
    },
    {
        value: type.LOCADOR,
        text: "Locador (secundário)",
    },
    {
        value: type.TESTEMUNHA,
        text: "Testemunha",
    },
]
const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains
}